export enum ReportingStatus {
  OK = 'OK',
  KO = 'KO',
}
